import { gql } from '@apollo/client'
import { USER_FRAGMENT } from './UserFragment'

export const REPORTED_ISSUE_FRAGMENT = gql`
  fragment ReportedIssue on ReportedIssue {
    id
    objectId
    issueType
    message
    created
    reportedBy {
      ...User
    }
  }
  ${USER_FRAGMENT}
`
